export default __webpack_public_path__ + "static/media/Aeonik-MediumItalic.f397ccdf.woff2";